<template>
  <div class="text-center">
    <div class="phone-template">
      <iframe frameborder="0" scrolling="auto" :src="url" class="iframe"></iframe>
      <div class="position-absolute bg-white qus-con body-padding-15 box-sizing">
        <div v-for="(item,index) in list" :key="index"
             class="margin-b-10 text-ellipsis cursor-pointer text-left qus-item" @click="qClick($event,index)">
          {{ item.name }} {{ htmlImg(item.descInfo) }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {listByQId} from '@/api/questionApi';
import {htmlImg} from '@/utils/common';
export default {
  name: "componentPreview",
  data() {
    return {
      list: [],
      ops: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {
          background: '#00000022'
        }
      },
      // url: process.env.WEB_URL + "preview/" + this.$route.params.id
      url: `${process.env.WEB_URL}preview/${this.$route.params.id}`
    }
  },
  methods: {
    htmlImg(content) {
      return htmlImg(content)
    },
    getQuestion(id) {
      listByQId({qid: id}).then(res => {
        this.list = res.data
      })
    },
    qClick(e, index) {
      e.preventDefault();url: 
      // this.url = `${process.env.WEB_URL}preview/${this.$route.params.id}?index=${index}`;
      this.url = process.env.WEB_URL + "preview/" + this.$route.params.id + '?index=' + index;
      if (document.getElementById('iframe')) {
        setTimeout(() => {
          document.getElementById(iframeid).contentWindow.location.reload(true);
        }, 200)
      }
    }
  },
  created() {
    const id = this.$route.params.id
    this.getQuestion(id)
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/scss/index.scss";

.phone-template {
  position: relative;
  margin-top: 10px;
  display: inline-block;
  width: 372px;
  height: 744px;
  background-image: url("../../../assets/phoneTemplate.jpeg");
  background-size: 372px 744px;
}

.qus-con {
  left: 400px;
  top: 20px;
  width: 320px;
  height: 704px;
  border-radius: 8px;
  overflow: auto;
}

.qus-item {
  border: 1px solid #dde5ed;
  font-size: 14px;
  border-radius: 4px;
  padding: 4px;
}

.qus-item:last-child {
  margin-bottom: 0;
}

.iframe {
  width: 318px;
  height: 568px;
  margin: 74px 0 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/qms/components/preview.vue